export const getMarkerIconOptions = (logo) => {
  return {
    // url: logo || "/assets/uni-hat.png",
    size: { width: 60, height: 60, f: "px", b: "px" },
    scaledSize: { width: 30, height: 30, f: "px", b: "px" },
  };
};
